import { Divider } from "antd";
import { DisplayWidth } from "./DisplayWidth.tsx";
import "./AppSettingsContent.scss";
import { useIntl } from "react-intl";
import { TableDensity } from "./TableDensity.tsx";
import { UserOptions } from "./UserOptions.tsx";

type Props = {
  closePopover: () => void;
};

export const AppSettingsContent = ({ closePopover }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <div className="app-settings-content">
      <div className="app-settings-content-title">{formatMessage({ id: "app.settings.title" })}</div>
      <Divider />
      <DisplayWidth />
      <TableDensity />
      <Divider />
      <UserOptions closePopover={closePopover} />
    </div>
  );
};
